import { stateGetters, stateSetters } from '@/utils/store/store-utils'

// Draft of what the user staged on the add-details screen (ItemAddDetails.vue):
// collections to move the item into, tags, and the post text intro. Nothing here
// is committed — the screen's Save applies it all at once.
//
// It lives in the store rather than in the component because creating a
// collection mid-flow navigates away to /collections/add and back, which
// remounts the screen. Without this, anything typed before that round trip would
// be silently lost. Deliberately in-memory only: a draft is meaningful for one
// add-details visit, not across app launches.
const defaultState = {
  itemId: null,
  collectionIds: [],
  tags: [],
  postText: '',
  // Whether the draft has taken over the item's already-saved tags / post text.
  // Seeding must happen once per item, not once per mount, or returning from the
  // create-collection page would wipe the user's edits back to the saved values.
  seeded: false,
}

export default {
  name: 'itemAddDetailsDraft',
  namespaced: true,
  state: () => ({ ...defaultState }),
  getters: {
    ...stateGetters(defaultState),
    isActiveFor: state => itemId => !!itemId && state.itemId === itemId,
  },
  mutations: {
    ...stateSetters(defaultState),
  },
  actions: {
    // Begin (or resume) the draft for an item. A different item means the
    // previous draft is stale and gets dropped.
    start({ state, commit }, { itemId }) {
      if (state.itemId === itemId) return

      commit('resetState')
      commit('setItemId', itemId)
    },
    // Take over the values the item was saved with (e.g. the auto-added "note"
    // tag) so they stay visible and are preserved on save.
    seed({ state, commit }, { tags, postText }) {
      if (state.seeded) return

      commit('setTags', tags)
      commit('setPostText', postText)
      commit('setSeeded', true)
    },
    addCollectionId({ state, commit }, collectionId) {
      if (!collectionId || state.collectionIds.includes(collectionId)) return

      commit('setCollectionIds', [...state.collectionIds, collectionId])
    },
    removeCollectionId({ state, commit }, collectionId) {
      commit('setCollectionIds', state.collectionIds.filter(id => id !== collectionId))
    },
    clear({ commit }) {
      commit('resetState')
    },
  },
}
